import React from 'react';
import { findDOMNode } from 'react-dom';
import TypeReference from './type-reference';

class TypeSelector extends React.Component {

    constructor(props) {
        super(props);

        this.state = { search: null, isLoading: false, hasMoreResults: false, objectData: null, isUserEnteringSearchTerm: false }

        this.getObjectData = this.getObjectData.bind(this);
        this.onSearchChange = this.onSearchChange.bind(this);
        this.onSearch = manywho.utils.debounce(this.onSearch, 750);
        this.onOnlyThisFlowChanged = this.onOnlyThisFlowChanged.bind(this);
        this.onTypeSelected = this.onTypeSelected.bind(this);
    }

    getObjectData(search, limit) {
        this.setState({ isLoading: true, isUserEnteringSearchTerm: false });

        manywho.ajax.dispatchObjectDataRequest(this.props.objectDataRequest, manywho.settings.global('adminTenantId'), null, this.props.authenticationToken, limit, search, null, null, 1)
            .then((response) => {
                this.setState({ objectData: response.objectData, isLoading: false, hasMoreResults: response.hasMoreResults });
            })
            .always(() => {
                this.setState({ isLoading: false, expanded: [] });
            });
    }

    onSearchChange(e) {
        this.setState({ search: e.target.value, hasMoreResults: false, isUserEnteringSearchTerm: true });
        this.onSearch(e.target.value);
    }

    onSearch(search) {
        this.getObjectData(search, manywho.utils.isNullOrWhitespace(search) ? manywho.settings.global('paging.value_selector') : 5000);
    }

    onOnlyThisFlowChanged(e) {
        this.props.objectDataRequest.configurationValues = [
            {
                contentType: manywho.component.contentTypes.string,
                developerName: 'FlowId',
                contentValue: (e.target.checked) ? this.props.flowId : null
            }
        ];

        this.setState({ isOnlyThisFlowEnabled: e.target.checked });
        this.onSearch(this.state.search);
    }

    onTypeSelected(objectData) {
        this.props.onChange(objectData);
    }

    componentDidMount() {
        findDOMNode(this.refs.search).focus();

        if (this.props.isVisible && this.props.objectDataRequest) {
            this.props.objectDataRequest.configurationValues = [
                {
                    contentType: manywho.component.contentTypes.string,
                    developerName: 'FlowId',
                    contentValue: null
                }
            ];

            this.getObjectData(null, 100);
        }
    }

    render() {
        let items = null;

        if (this.state.objectData && this.state.objectData.length > 0)
            items = this.state.objectData.map(objectData => {
                let isSelected = false;

                if (this.props.reference)
                    isSelected = manywho.utils.getObjectDataProperty(objectData.properties, 'Id').contentValue == manywho.utils.getObjectDataProperty(this.props.reference.properties, 'Id').contentValue;

                return <TypeReference reference={objectData} onClick={this.onTypeSelected.bind(null, objectData)} isSelected={isSelected} search={this.state.isLoading || this.state.isUserEnteringSearchTerm ? null : this.state.search} />
            });

        let noItems = null;
        let onlyThisFlow = null;
        let tooManyResults = null;

        if (items && items.length > 0)
            items = <div className="value-selector-items">
                {items}
            </div>;
        else if ((!items || items.length == 0) && (!manywho.utils.isNullOrWhitespace(this.state.search) && !this.state.isLoading))
            noItems = <div className="value-selector-no-results">No Types found</div>;

        if (this.state.hasMoreResults) {
            tooManyResults = <p>{'More than ' + manywho.settings.global('paging.value_selector', this.props.flowKey) + ' Types were found, try searching for a more specific name'}</p>

            if (!manywho.utils.isNullOrWhitespace(this.props.flowId))
                onlyThisFlow = <div className="form-group">
                    <label>
                        <input type="checkbox" checked={this.state.isOnlyThisFlowEnabled} onChange={this.onOnlyThisFlowChanged} /> Only show Types already being used in this Flow
                    </label>
                </div>
        }

        return (<div className="value-selector">
            <div className="select-or-new-value">
                <input type="text" className="form-control" placeholder="Start typing to search for a Type" value={this.state.search} onChange={this.onSearchChange} ref="search" />
            </div>
            {tooManyResults}
            {onlyThisFlow}
            {items}
            {noItems}
            <button className="btn btn-default btn-outline" onClick={this.props.onCancel}>Cancel</button>
            {this.state.isLoading && React.createElement(manywho.component.getByName('wait'), { isVisible: true }, null)}
        </div>);
    }

}

export default TypeSelector;
